import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import firebaseapp from './firebaseapp.js';

const firestoreDB = firebaseapp.firestore();
const styles = theme => ({
    container: {
        position: 'relative',
        minHeight: "100vh"
    }
});

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        this.logErrorToFirebase(error, errorInfo);
    }

    logErrorToFirebase(error, errorInfo) {

        let errorToLog = {
            type: error.toString(),
            useremail: sessionStorage.userEmail,
            componentStack: errorInfo.componentStack,
            url: window.location.href,
            timestampDisplay: new Date().toString(),
            timestamp: Date.now()
        };

        console.log({errorToLog});
        firestoreDB.collection("errors").add(
            errorToLog
        )
            .then(function (docRef) {
                console.log("error logged to firebase");
                console.log({docRef});

            })
            .catch(function (error) {
                console.log("failed to log error to firebase");
                console.log({error});
            });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <Typography variant={"h5"} align={"center"}>{this.props.message || 'Alas! Something went wrong! Please refresh.'}</Typography>;
        }

        return this.props.children;
    }
}

export default withStyles(styles, {withTheme: true})(ErrorBoundary);